import { Doc } from "@/components/Doc/Doc";
import { FlashOnChangeTD } from "@/components/FlashOnChange/FlashOnChange";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import {
  cumulativePrincipalRepaidTableListAtom,
  InvestorTypeId,
} from "@/financeModels/owasco/returnMetrics";
import { monospaceFontFamily, textFontFamily } from "@/theme";
import { isNumber } from "@/utils/math";
import { formatMoney } from "@/utils/moneyFormating";
import { Group, Table, Text } from "@mantine/core";
import { useAtomValue } from "jotai";

export const CumulativePrincipalRepaymentTable = ({
  selectedInvestorTypeId,
}: {
  selectedInvestorTypeId: InvestorTypeId;
}) => {
  const tables = useAtomValue(cumulativePrincipalRepaidTableListAtom);
  const table = tables.find((t) => t.id === selectedInvestorTypeId);
  const items = [...(table?.cumulativePrincipalRepaid || [])];

  return (
    <Table striped withColumnBorders>
      <Table.Thead
        style={{
          position: "sticky",
          top: "0",
          background: "white",
        }}
      >
        <Table.Tr>
          <Table.Th
            ta={"center"}
            style={{
              whiteSpace: "nowrap",
            }}
          >
            <LabelExplainer
              justify="center"
              lh={1.6}
              label={
                <>
                  Cumulative <br />
                  Principal Repaid
                </>
              }
              explanation={
                <Doc
                  path={
                    "@/docs/pages/model/roi/id-cumulative-principal-repaid.mdx"
                  }
                />
              }
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody ff={monospaceFontFamily}>
        {items.map((val, i) => {
          return (
            <Table.Tr key={i}>
              <FlashOnChangeTD
                content={val?.toString()}
                ta={"right"}
                miw={140}
                style={{ whiteSpace: "nowrap" }}
              >
                {val === null && (
                  <Group w={"100%"} gap={0} justify="center">
                    <Text inherit opacity={0} w={0} c="transparent">
                      placeholder
                    </Text>
                    <Text ff={textFontFamily} fz={12} ta={"center"}>
                      Principal Returned
                    </Text>
                  </Group>
                )}
                {isNumber(val) && formatMoney(val)}
                {!isNumber(val) && val !== null && "—"}
              </FlashOnChangeTD>
            </Table.Tr>
          );
        })}
      </Table.Tbody>
    </Table>
  );
};
